<template>
    <v-container grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <p class="subtitle">Merge tags:</p>
                <ul>
                    <li v-for="tag in data.mtags">{{ tag.mtag }} - {{ tag.value }}</li>
                </ul>
            </v-flex>
        </v-layout>
        <div>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-checkbox
                            v-model="data.email"
                            label="Email"
                            required
                    ></v-checkbox>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-if="data.email">
                <v-flex xs12 sm12 md12>
                    <v-text-field
                            v-validate="''"
                            v-model="data.email_subject"
                            :error-messages="errors.collect('data.email_subject')"
                            label="Subject"
                            data-vv-name="data.email_subject"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                    <p class="subtitle">Text</p>
                    <vue-editor v-model="data.email_text"></vue-editor>
                </v-flex>
            </v-layout>
        </div>
        <div>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-checkbox
                            v-model="data.database"
                            label="Database"
                            required
                    ></v-checkbox>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-if="data.database">
                <v-flex xs12 sm12 md12>
                    <v-text-field
                            v-validate="''"
                            v-model="data.database_text"
                            :error-messages="errors.collect('data.database_text')"
                            label="Text"
                            data-vv-name="data.database_text"
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </div>
        <!--<div>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-checkbox
                            v-model="data.push"
                            label="Push"
                            required
                    ></v-checkbox>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-if="data.push">
                <v-flex xs12 sm12 md12>
                    <p class="subtitle">Text</p>
                    <vue-editor v-model="data.push_text"></vue-editor>
                </v-flex>
            </v-layout>
        </div>-->
        <div>
            <v-flex xs12 sm12 md12>
                <v-btn color="primary" @click.prevent="create">Guardar</v-btn>
            </v-flex>
        </div>
    </v-container>
</template>

<script>
    import { DICCIONARIO } from '../../../../diccionario';
    import { VueEditor } from "vue2-editor";

    export default {
        props: ['id'],
        data : function() {
            return {
                data : {},
                dictionary: DICCIONARIO,
            }
        },
        created: function () {
            this.getNotification(this.id);
            this.setSectionTitle();
        },
        mounted () {
            this.$validator.localize('en', this.dictionary)
        },
        methods: {
            getNotification(id) {
                this.$store.dispatch('getNotification', {
                    id : id
                }).then((res) => {

                    this.data = res.data.data;

                }).catch((error) => {

                });
            },
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Edit notification'
                });
            },
            create : function() {

                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('editNotification', this.data).then((res) => {

                            this.$router.push({ name: 'admin.notifications.list' });

                        }).catch((error) => {

                        });
                    }
                });

            }
        },
        components: {
            VueEditor
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/config/notifications/EditComponent.vue